import { useState, useEffect } from 'react';
import { Form, Input, Button, message, Card, Collapse } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import API from '../api/client';

const ContactSettingsPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    API.get('/contact').then((res) => {
      if (res.data && res.data._id) form.setFieldsValue(res.data);
    });
  }, [form]);

  const handleSave = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();
      await API.put('/contact', values);
      message.success('Kaydedildi');
    } catch { message.error('Hata oluştu'); }
    setLoading(false);
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>İletişim Sayfası Ayarları</h2>
        <Button type="primary" onClick={handleSave} loading={loading}>Kaydet</Button>
      </div>

      <Form form={form} layout="vertical">
        <Collapse
          defaultActiveKey={['hero', 'info', 'form']}
          items={[
            {
              key: 'hero',
              label: 'Hero Alanı',
              children: (
                <Card bordered={false}>
                  <Form.Item name={['hero', 'badge']} label="Badge Metni">
                    <Input placeholder="Bize Ulaşın" />
                  </Form.Item>
                  <Form.Item name={['hero', 'title']} label="Başlık">
                    <Input placeholder="İletişim" />
                  </Form.Item>
                  <Form.Item name={['hero', 'description']} label="Alt Açıklama">
                    <Input placeholder="Soru, öneri ve talepleriniz için..." />
                  </Form.Item>
                </Card>
              ),
            },
            {
              key: 'info',
              label: 'İletişim Bilgileri',
              children: (
                <Card bordered={false}>
                  <Form.Item name={['info', 'address']} label="Adres">
                    <Input.TextArea rows={2} />
                  </Form.Item>
                  <Form.Item name={['info', 'phone']} label="Telefon">
                    <Input placeholder="0546 664 16 02" />
                  </Form.Item>
                  <Form.Item name={['info', 'email']} label="E-posta">
                    <Input placeholder="info@dihiz.com" />
                  </Form.Item>
                  <Form.Item name={['info', 'workingHours']} label="Çalışma Saatleri">
                    <Input placeholder="Pazartesi - Cumartesi: 09:00 - 18:00" />
                  </Form.Item>
                </Card>
              ),
            },
            {
              key: 'map',
              label: 'Harita',
              children: (
                <Card bordered={false}>
                  <Form.Item name={['map', 'embedUrl']} label="Google Maps Embed URL" extra="Google Maps'ten 'Paylaş > Haritayı yerleştir' ile alınan iframe src URL'si">
                    <Input.TextArea rows={3} placeholder="https://www.google.com/maps/embed?pb=..." />
                  </Form.Item>
                </Card>
              ),
            },
            {
              key: 'social',
              label: 'Sosyal Medya',
              children: (
                <Card bordered={false}>
                  <Form.Item name={['socialLinks', 'facebook']} label="Facebook">
                    <Input placeholder="https://facebook.com/..." />
                  </Form.Item>
                  <Form.Item name={['socialLinks', 'twitter']} label="Twitter / X">
                    <Input placeholder="https://twitter.com/..." />
                  </Form.Item>
                  <Form.Item name={['socialLinks', 'instagram']} label="Instagram">
                    <Input placeholder="https://instagram.com/..." />
                  </Form.Item>
                  <Form.Item name={['socialLinks', 'google']} label="Google">
                    <Input placeholder="https://..." />
                  </Form.Item>
                </Card>
              ),
            },
            {
              key: 'form',
              label: 'İletişim Formu',
              children: (
                <Card bordered={false}>
                  <Form.Item name={['form', 'title']} label="Form Başlığı">
                    <Input placeholder="Mesaj Gönderin" />
                  </Form.Item>
                  <Form.Item name={['form', 'description']} label="Form Açıklaması">
                    <Input.TextArea rows={2} />
                  </Form.Item>
                  <Form.Item name={['form', 'successMessage']} label="Başarı Mesajı" extra="Form gönderildikten sonra gösterilecek mesaj">
                    <Input.TextArea rows={2} />
                  </Form.Item>
                </Card>
              ),
            },
            {
              key: 'seo',
              label: <span><GlobalOutlined /> SEO Ayarları</span>,
              children: (
                <Card bordered={false}>
                  <Form.Item name={['seo', 'metaTitle']} label="Meta Başlık">
                    <Input placeholder="İletişim | Dihiz A.Ş." />
                  </Form.Item>
                  <Form.Item name={['seo', 'metaDescription']} label="Meta Açıklama">
                    <Input.TextArea rows={2} maxLength={160} showCount />
                  </Form.Item>
                  <Form.Item name={['seo', 'metaKeywords']} label="Anahtar Kelimeler">
                    <Input placeholder="dihiz, iletişim, didim" />
                  </Form.Item>
                  <Form.Item name={['seo', 'ogImage']} label="OG Görsel URL">
                    <Input placeholder="https://..." />
                  </Form.Item>
                </Card>
              ),
            },
          ]}
        />

        <div style={{ marginTop: 24, textAlign: 'right' }}>
          <Button type="primary" onClick={handleSave} loading={loading} size="large">Kaydet</Button>
        </div>
      </Form>
    </>
  );
};

export default ContactSettingsPage;
